import { render, staticRenderFns } from "./Scrollbar.vue?vue&type=template&id=b6767de0&scoped=true&"
import script from "./Scrollbar.vue?vue&type=script&lang=ts&"
export * from "./Scrollbar.vue?vue&type=script&lang=ts&"
import style0 from "./Scrollbar.vue?vue&type=style&index=0&id=b6767de0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6767de0",
  null
  
)

export default component.exports